import { render, staticRenderFns } from "./DynamicLayoutWrapper.vue?vue&type=template&id=305f6d15&"
import script from "./DynamicLayoutWrapper.vue?vue&type=script&lang=js&"
export * from "./DynamicLayoutWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports